import React from "react";
import { Reveal } from "./Ornament";
import { Heart, Users, Award } from "lucide-react";

/** Social proof strip — the "MC" reference site has "200+ nights of trust".
 *  We do the equivalent in English + venue attribution logos. */
export default function SocialProof() {
  const stats = [
    { icon: Heart,  value: "200+", label: "Trust evenings" },
    { icon: Users,  value: "60k+", label: "Enchanted guests" },
    { icon: Award,  value: "12",   label: "Countries of Production" },
  ];
  const clients = [
    "The Bay Hotel",
    "Vogue Italia",
    "Prada",
    "Nova Brands",
    "Maison de Reve",
    "Grand Bretagne",
  ];
  return (
    <section
      className="relative bg-[var(--lu-cream)] border-y border-[var(--lu-gold)]/30 py-16"
      data-testid="social-proof-section"
    >
      <div className="container-lux">
        <Reveal>
          <p className="text-center kicker text-[var(--lu-gold-dark)]">Trusted throughout Europe &amp; the Mediterranean</p>
        </Reveal>

        {/* Numbers */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal delay={Math.min(i + 1, 6)} key={s.label}>
                <div
                  className="flex flex-col items-center text-center"
                  data-testid={`stat-${i}`}
                >
                  <Icon size={22} className="text-[var(--lu-gold-dark)]" />
                  <p className="mt-4 font-serif text-[56px] leading-none text-[var(--lu-black)]">
                    {s.value}
                  </p>
                  <p className="mt-2 font-micro text-[10px] text-black-70">
                    {s.label}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Client strip */}
        <Reveal delay={2}>
          <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {clients.map((c, i) => (
              <span
                key={c}
                className="font-serif italic text-[18px] sm:text-[20px] text-black-60 hover:text-[var(--lu-gold-dark)] transition-colors"
                data-testid={`client-logo-${i}`}
              >
                {c}
                {i < clients.length - 1 && (
                  <span className="ml-10 h-1 w-1 inline-block rounded-full bg-[var(--lu-gold-dark)]/50 align-middle" />
                )}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
